import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

// 问卷
const openQuestion = new Restful(project, 'open')
openQuestion.questionQuery = data => {
  const url = project + 'open/question/query'
  return http.get(url, data).then(res => {
    return res
  })
}

const openReviewer = new Restful(project, 'open')
openReviewer.reviewsCode = (id, data) => {
  const url = project + 'open/reviewer/invite/code/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

// 确认审稿
openReviewer.confirmCode = (id, data) => {
  const url = project + 'open/reviewer/invite/confirm/code/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

// 提交决策
openReviewer.reviewComment = (id, data) => {
  const url = project + 'open/reviewer/invite/code/' + id
  return http.post(url, data).then(res => {
    return res
  })
}
// 查看报告
openReviewer.reviewReport = (id, data) => {
  const url = project + 'open/reviewer/invite/report/code/' + id
  return http.get(url, data).then(res => {
    return res
  })
}

// 生成审稿证书
openReviewer.certificate = (id, data) => {
  const url = project + `open/manuscript/reviewer/certificate_code/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}
const openJournal = new Restful(project, 'open/journal')

// 外编
const openAcademic = new Restful(project, 'open')

openAcademic.academicCode = (id, data) => {
  const url = project + 'open/macademic/code/' + id
  return http.get(url, data).then(res => {
    return res
  })
}
// 最新版本审稿报告（现不用）
// openAcademic.academicReviewer = (id, type, data) => {
//   const url = project + `open/macademic/${id}/decision/${type}/reviewer`
//   return http.get(url, data).then(res => {
//     return res
//   })
// }
// 所有版本审稿报告（新）
openAcademic.academicReviewer = (id, data) => {
  const url = project + `open/macademic/${id}/reviewer`
  return http.get(url, data).then(res => {
    return res
  })
}

openAcademic.academicCommit = (code, data) => {
  const url = project + `open/macademic/code/${code}`
  return http.post(url, data).then(res => {
    return res
  })
}

// 作者
const openAuthor = new Restful(project, 'open')

openAuthor.authorMascript = (id, data) => {
  const url = project + `open/manuscript/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}

openAuthor.authorReport = (id, data) => {
  const url = project + `open/manuscript/author/review_report/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}

openAuthor.authorReportReply = data => {
  const url = project + `open/manuscript/author/review_report`
  return http.post(url, data).then(res => {
    return res
  })
}

openAuthor.authorRevise = data => {
  const url = project + `open/manuscript/author/revision`
  return http.post(url, data).then(res => {
    return res
  })
}

export { openQuestion, openReviewer, openAcademic, openAuthor, openJournal }
